import type { LiveConsultConnectionResponse } from "@/App/components/liveConsult/types/LiveConsultConnectionResponse";
import type { LiveConsultService } from "@/App/components/liveConsult/types/LiveConsultService";

import config from "@/App/config/main";
import { HttpClient } from "@/App/services/httpClient/HttpClient";

export const liveConsultService: LiveConsultService = {
  getLiveConsultToken: ({ caseId }: { caseId: string }): Promise<LiveConsultConnectionResponse> => {
    return HttpClient.get({ path: `${config.API_URL}/notification/twiage-cases/${caseId}/room` });
  },
};
